import { RefreshCw, Save } from "lucide-react";

function SettingsHeader({ reload }) {

    return (

        <div className="settings-header">

            <div>

                <h1>Platform Settings</h1>

                <p>

                    Configure HomeFoods platform settings.

                </p>

            </div>

            <div className="settings-header-actions">

                <button
                    className="refresh-btn"
                    onClick={reload}
                >
                    <RefreshCw size={18} />
                    Refresh
                </button>

                <button className="save-btn">

                    <Save size={18} />

                    Save Changes

                </button>

            </div>

        </div>

    );

}

export default SettingsHeader;